export const status = {
  label: 'Status',
  key: 'status',
  icon: 'pulse',
  tooltip: 'Limit results to live or draft entries.',
  options: [{
    value: 'live',
    label: 'Live'
  }, {
    value: 'draft',
    label: 'Draft'
  }]
}

// Group and category options come from the API, so these are factories that
// build a facet definition from the loaded rows.
export const group = (groups) => {
  return {
    label: 'Group',
    key: 'group_id',
    icon: 'select-group',
    tooltip: 'Limit results to a topic group (menu pill).',
    options: groups.map(group => {
      return {
        value: group.id,
        label: group.name
      }
    })
  }
}

export const category = (categories) => {
  return {
    label: 'Category',
    key: 'category_id',
    icon: 'view-grid-outline',
    tooltip: 'Limit results to the app page the question appears on.',
    options: categories.map(category => {
      return {
        value: category.id,
        label: category.label
      }
    })
  }
}
